import React from 'react';
import clsx from 'clsx';
import styles from './Card.module.css';

type TProps = {
  children: React.ReactNode;
  testId?: string;
  className?: string;
};

export const Card = ({ children, testId, className, ...props }: TProps) => {
  const dataTestId = `card${testId ? `-${testId}` : ''}`;

  return (
    <div
      data-testid={dataTestId}
      className={clsx(styles.cardContainer, className)}
      {...props}
    >
      {children}
    </div>
  );
};
